export const COLORS = {
  primary: "#437986",
  activeBg: "#CCE0E1",
  softBg: "#80BECD",
  texWhite: "#ffffffff",
  texBlack: "#111827",
  textGray: "#6b7280",
  danger: "#ef4444",
  success: "#16A34A",
  warning: "#FFCC00",
};
